import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/services/main/main.service';
import { ContractDialogComponent } from '../../contract/contract-modal/contract-modal.component';
import { getUserProfile } from 'src/app/core/session';
@Component({
  selector: 'app-dispute-list',
  templateUrl: './dispute-list.component.html',
  styleUrls: ['./dispute-list.component.scss']
})
export class DisputeListComponent implements OnInit {

  pfStatus = 3;
  searchString: any = '';
  allContracts = [];
  popup: Boolean;
  contractData: {
    "contract_id": number;
    "contract_code": string;
    "last_dispute_date": string;
    pp_id: any;
    payment_process_code: any;
    status: any;
  }[] = [];
  offset = 0;
  limit = 0;
  totalRecords = 0;
  totalPages: any = 0;
  selectedDisputes = 0;
  prev_search: any;
  viewId: any;
  clicklistner: any;
  constructor(
    public mainService: MainService,
    public router: Router,
    public _ActiveRoute: ActivatedRoute,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.getcontractList();
    if (window.location.search != '') {
      this.getcontractListFromId();
    }
    this._ActiveRoute.queryParams.subscribe((params) => {
      if (this.viewId != params.id) {
        this.viewId = params.id;
        this.getcontractListFromId()
      }
    })
  }

  show_popup() {
    if (!this.popup) {
      setTimeout(() => {
        this.popup = true;
      }, 100)
    }
  }

  searchContract() {
    if (this.searchString || this.prev_search != this.searchString) {
      this.offset = 0;
      this.getcontractList();
    }
  }

  searchClear() {
    this.searchString = '';
    this.offset = 0;
    this.getcontractList();
  }

  getcontractList() {
    try {
      let button = document.querySelector('.buttonlist-toggle');
      if (button) {
        button['blur']();
      }
      let userData = getUserProfile()
      if (userData) {
        let data = {
          access_token: userData.access_token,
          doctor_id: userData.doctor_id,
          limit: 10,
          offset: this.offset,
          code: this.selectedDisputes || 0,
          search: this.searchString
        }
        this.prev_search = this.searchString;
        this.mainService.api(data, 'get_doctor_disputes', false).subscribe((data) => {
          if (data.is_error) {
            this.mainService.customPopups(data.err || 'Oppse something went wrong.', 1);
          }
          this.contractData = data.contracts_list.map((item) => {
            return { ...item, "last_dispute_date": new Date(item.last_dispute_date) }
          });
          this.totalRecords = data.number_of_records;
          this.totalPages = data.number_of_pages;
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  getcontractListFromId() {
    try {
      let button = document.querySelector('.buttonlist-toggle');
      if (button) {
        button['blur']();
      }
      let params;
      params = new URLSearchParams(window.location.search)
      this.viewId = params.get('id');
      if (!params) return;
      let userData = getUserProfile()
      if (userData) {
        let data = {
          access_token: userData.access_token,
          doctor_id: userData.doctor_id,
          limit: 10,
          offset: this.offset,
          code: this.selectedDisputes || 0,
          search: params.get('id')
        }
        this.mainService.api(data, 'get_doctor_disputes', false).subscribe((data) => {
          try {
            if (data.is_error) {
              this.mainService.customPopups(data.err || 'Oppse something went wrong.', 1);
            }

            if (window.location.search != '') {
              setTimeout(() => {
                if (params.get('type') == 'dispute' && data.contracts_list && data.contracts_list.length > 0) {
                  let contract_data = { contract_id: data.contracts_list[0].contract_id, pp_id: data.contracts_list[0].pp_id, pp_subscription_id: data.contracts_list[0].pp_subscription_id, contract_code: data.contracts_list[0].contract_code, pp_code: data.contracts_list[0].payment_process_code, pp_subscription_code: data.contracts_list[0].pp_subscription_code, code: data.contracts_list[0].status.code }
                  this.getContractDetailsDisputes(contract_data);
                }
              }, 200)
            }
          } catch (error) {
            console.log(error);
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  changePage(pageNumber) {
    if (this.totalRecords > 0) {
      this.offset = pageNumber * 10
      this.getcontractList();
    }
  }

  viewContractDisputeDetails(contractId,contractDocsRequired,disutedPayments) {
    let confirmDialogRef = this.dialog.open(ContractDialogComponent, {
      width: '550px',
      panelClass: 'rightFullDialog_1',
      data: {
        title: 'Delete Payment',
        desc: 'Are you sure you want to delete the payment?',
        action: 'Delete',
        actionClass: 'delete-button',
        type: 60,
        ...contractId,
        contractDocsRequired,
        disutedPayments,
        doctor_id: getUserProfile().doctor_id
      }
    });
    confirmDialogRef.afterClosed().subscribe((result) => {
      if (this.viewId) {
        this.router.navigate(['app/profile'])
      }
      else {
        this.getcontractList();
      }
    })
  }

  getContractDetailsDisputes(contractId) {
    try {
      let userData = getUserProfile()
      if (userData) {
        let data = {
          access_token: userData.access_token,
          doctor_id: userData.doctor_id,
        }

        if(contractId.pp_subscription_id){
          console.log(contractId, 'contractId');
          data['pp_subscription_id'] = contractId.pp_subscription_id;
        } else {
          data['contract_id'] = contractId.contract_id;
          data['pp_id'] =  contractId.pp_id;
        }
        this.mainService.api(data, 'get_doctor_disputes', false).subscribe((data) => {
          if (data.is_error) {
            this.mainService.customPopups(data.err || 'Oppse something went wrong.', 1);
            return
          }
          let contractDocsRequired = data.documents_required.sort((a, b) => a.uploaded == 1 ? b : a);
          let disutedPayments = data.disputed_payments;
          this.viewContractDisputeDetails(contractId,contractDocsRequired,disutedPayments)
        })
      }
    } catch (error) {
        console.log(error)
    }
}
  

  viewContract(contract, is_pp) {
    if(contract && contract.is_ar == 1 && !contract.contract_id) {
      this.router.navigate(['app/accounts-receivable/details'], { queryParams: { processId: contract.pp_id || contract.contract_id }, queryParamsHandling: "merge" })
      return;
    }
    if (contract && contract.contract_id) {
      this.router.navigate(['/app/contract/details'], { queryParams: { contractId: contract.contract_id }, queryParamsHandling: "merge" })
      return;
    }
    if (contract.payment_process_code && contract && contract.pp_id && !contract.is_arr) {
      this.router.navigate(['app/process-payment/details'], { queryParams: { processId: contract.pp_id }, queryParamsHandling: "merge" })
      return;
    }

    if (contract && contract.pp_subscription_id ) {
      // tslint:disable-next-line:max-line-length
      this.router.navigate(['app/process-payment/sub-details'], { queryParams: { processId: contract.pp_subscription_id }, queryParamsHandling: "merge" })
      return;
    }
  }


  ngAfterViewInit() {
    this.clicklistner = window.addEventListener('click', (event) => {
      if (this.popup == true && event) {
        this.popup = false;
      }
    })
  }

  ngOnDestory(){
    this.clicklistner && window.removeEventListener('click',this.clicklistner);
  }
  
}